import React from 'react'
import Banner from '../components/UI-layout/banner'
import { CommonStyle } from '../styles/common-styles'
import downloadIcon from '../public/images/download.png';
import toolIcon from '../public/images/fa-solid_tools.png';
import userIcon from '../public/images/bxs_user-check.png';
import CarouselItem from '../components/UI-layout/carousal-item';
import wireframeBg from '../public/images/wireframe-bg.png';
import Link from 'next/link';
import UseWindowSize from '../hooks/helpers/useWindowSize';
import ReactPlayer from 'react-player';
import ScrollContainer from 'react-indiana-drag-scroll';
import Head from 'next/head';
import { carCreditProgramTopContent, customerReviews } from '../utils/wordings';
import { DownloadAppFooter } from '../components/download-app-footer';
import { tagButton } from '../utils/lib/events';
import { useRouter } from 'next/router';
import Image from 'next/image';

function FuelDelivery() {
    const router = useRouter();
    const screenProps = UseWindowSize();

    return (
        <div className="container-fluid p-0">
            <Head>
                <title>Paleo Car Care - Expert Auto Maintenance for Your Peace of Mind</title>
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta name="description" content="Discover the best in auto care with Paleo Car Care - Your trusted partner for top-notch car maintenance services." />
                <meta name="author" content="Paleo Car Care" />
                <meta property="og:title" content="Paleo Car Care - Car Credit Program: Drive Home Your Dream Car with Ease" />
                <meta property="og:image" itemProp="image" content="/images/referral-banner.png" />
                <meta name="facebook-domain-verification" content="m4o6pn81efn34qkf6t3fimmjnhbuxs" />
                <link rel="shortcut icon" href="../public/assets/images/favicon.ico" />
                <link rel="shortcut icon" href="/favicon.ico" />
                <link rel="alternate" href="https://www.paleocarcare.com/carcreditprogram.html" hrefLang="en" />
            </Head>
            <CommonStyle>
                <Banner content={carCreditProgramTopContent} />
                <div className="bg-white mt-md-4 py-lg-5">
                    <div className="caption container text-center py-5 d-lg-flex justify-content-center align-items-center" >
                        <Link href={'/get-mobile-app'}><div className="col-md-8 mb-5 mb-lg-0 mx-auto col-lg-4 px-lg-1">
                            <Image
                                src={downloadIcon.src}
                                alt="icon"
                                className="img-fluid"
                                width={80}
                                height={80}
                            />
                            <p className="mb-0 dark-text mt-4 heavy-bold big-title ">
                                Download The App
                            </p>
                        </div>
                        </Link>
                        <div className="col-md-8 mb-5 mb-lg-0 mx-auto col-lg-4 px-lg-1">
                            <Image
                                src={toolIcon.src}
                                alt="icon"
                                className="img-fluid"
                                width={80}
                                height={80}
                            />
                            <p className="mb-0 dark-text mt-4  big-title ">
                                Place An Order
                            </p>
                        </div>
                        <div className="col-md-8 mb-5 mb-lg-0 mx-auto col-lg-4 px-lg-1">
                            <Image
                                src={userIcon.src}
                                alt="icon"
                                className="img-fluid"
                                width={80}
                                height={80}
                            />
                            <p className="mb-0 dark-text mt-4  big-title ">
                                Free Inspection
                            </p>
                        </div>
                    </div>
                </div>
                <div className='bg-light-white container py-lg-5'>

                    <div className='d-md-flex pt-5 px-5'>
                        <div className="col-md-6 caption mx-auto " >
                            <div className='col-md-10'>
                                <h1 className='heavy-bold mb-4'>
                                    The Cost
                                </h1>
                                <h3 className='text-black light-weigth'>$4.99 per trip Convenience fee for Regular Members, Free for Premium Members</h3>
                                <p className='grey-text'>We monitor average gas prices in your area so you just have to pay for the convenience of our driver making your life easier!</p>
                                <h3 className='text-black light-weigth'>What about gas prices?</h3>
                                <p className='grey-text'>We work very hard to keep our gas prices in the same range as what you would pay at a gas station.</p>
                            </div>
                        </div>
                        <div className="col-md-6 caption mx-auto ">
                            <div className='col-md-10'>
                            <h2 className='heavy-bold mb-4 fs-2'>
                                    Earn Rewards
                                </h2>
                                {/* <h2 className='heavy-bold mb-4 fs-2'>
                                    Earn Rewards
                                </h2> */}
                                <h3 className='text-black light-weigth'>$0.05 per Gallon for Regular Members, $0.10 per Gallon for Premium Members</h3>
                                <p className='grey-text'>Every time you place a gas delivery order, you’ll earn Paleo Car Care credits for every gallon of gas you order. Need 10 gallons? Congrats, you just earned $1.00 in Paleo Car Care Credits, which you can track and access at any time in your Paleo Car Care Wallet within the app!</p>
                                <h3 className='text-black light-weigth'>$20 a Referral</h3>
                                <p className='grey-text'>We also want to reward you for letting your friends, neighbors, coworkers and more know how much you love this app, so anytime you Refer a Friend via the app, you’ll each earn $20 in Paleo Car Care Credits when they order their first gas delivery!</p>

                            </div>
                        </div>
                    </div>
                    <Link href={'/membership'}><button 
                    className='btn btn-danger py-3 mb-5 mx-5'
                    onClick ={()=>{tagButton ({url:router.pathname, item_name:"See Membership Benefits"})}}
                    >See Membership Benefits</button></Link>
                </div>

                {/* <div className="py-5">
                    <div className="caption mx-auto text-center" style={{ maxWidth: 380 }}>
                        <h1 className="heavy-bold text-center">
                            Loved by thousands of Customers like you
                        </h1>
                    </div>
                    <div className="mt-5 py-5 ms-md-5">
                        <ScrollContainer className="scroll-container d-flex py-5" style={{ gap: 20 }} horizontal={true}>
                            {customerReviews?.map((value, index) => <CarouselItem key={`item-${index}`} review={value} />)}

                        </ScrollContainer>
                    </div>

                </div> */}

        <DownloadAppFooter />
      </CommonStyle>
    </div>
  );
}

export default FuelDelivery;
